/* ============================================================
   EASTER HUNT 2026 — Core logic
   ============================================================
   Залежить від: window.EASTER_CONFIG (з snippets/easter-config.liquid)
   Залежить від: easter-hunt.css
   ============================================================ */

(function () {
  'use strict';

  if (!window.EASTER_CONFIG) {
    console.warn('[EasterHunt] EASTER_CONFIG not found. Game disabled.');
    return;
  }
  var CFG = window.EASTER_CONFIG;

  // ─── SVG яєць — 6 різних кольорів/візерунків ───────────────
  function buildEggSvg(light, mid, dark, stroke, pattern) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 80">' +
      '<defs><radialGradient id="EGGID" cx="35%" cy="30%">' +
        '<stop offset="0%" stop-color="' + light + '"/>' +
        '<stop offset="55%" stop-color="' + mid + '"/>' +
        '<stop offset="100%" stop-color="' + dark + '"/>' +
      '</radialGradient></defs>' +
      '<path d="M32,6 C14,6 6,30 6,48 C6,66 18,76 32,76 C46,76 58,66 58,48 C58,30 50,6 32,6 Z" fill="url(#EGGID)" stroke="' + stroke + '" stroke-width="1"/>' +
      pattern +
      '<ellipse cx="22" cy="18" rx="5" ry="9" fill="#fff" opacity="0.45"/>' +
    '</svg>';
  }

  // Візерунки
  var PATTERN_FLOWERS =
    '<path d="M6,42 L12,38 L18,42 L24,38 L30,42 L36,38 L42,42 L48,38 L54,42 L58,40" stroke="#fff" stroke-width="1.5" fill="none" stroke-linecap="round"/>' +
    '<path d="M6,54 L12,58 L18,54 L24,58 L30,54 L36,58 L42,54 L48,58 L54,54 L58,56" stroke="#fff" stroke-width="1.5" fill="none" stroke-linecap="round"/>' +
    '<g transform="translate(32,26)">' +
      '<circle cx="-3" cy="-2" r="2" fill="#fff"/>' +
      '<circle cx="3" cy="-2" r="2" fill="#fff"/>' +
      '<circle cx="-3" cy="2" r="2" fill="#fff"/>' +
      '<circle cx="3" cy="2" r="2" fill="#fff"/>' +
      '<circle r="1.3" fill="#ffd700"/>' +
    '</g>' +
    '<g transform="translate(32,68)">' +
      '<circle cx="-2.5" cy="-2" r="1.5" fill="#fff"/>' +
      '<circle cx="2.5" cy="-2" r="1.5" fill="#fff"/>' +
      '<circle cx="-2.5" cy="2" r="1.5" fill="#fff"/>' +
      '<circle cx="2.5" cy="2" r="1.5" fill="#fff"/>' +
      '<circle r="1" fill="#ffd700"/>' +
    '</g>';

  var PATTERN_DOTS =
    '<g fill="#fff" opacity="0.9">' +
      '<circle cx="18" cy="28" r="2"/>' +
      '<circle cx="32" cy="24" r="2"/>' +
      '<circle cx="46" cy="28" r="2"/>' +
      '<circle cx="14" cy="42" r="2.2"/>' +
      '<circle cx="28" cy="40" r="2.2"/>' +
      '<circle cx="42" cy="40" r="2.2"/>' +
      '<circle cx="50" cy="44" r="2"/>' +
      '<circle cx="18" cy="56" r="2"/>' +
      '<circle cx="32" cy="58" r="2"/>' +
      '<circle cx="46" cy="56" r="2"/>' +
      '<circle cx="24" cy="68" r="1.5"/>' +
      '<circle cx="40" cy="68" r="1.5"/>' +
    '</g>';

  var PATTERN_CHEVRONS =
    '<path d="M8,34 L20,28 L32,34 L44,28 L56,34" stroke="#fff" stroke-width="2.5" fill="none" stroke-linejoin="round" stroke-linecap="round"/>' +
    '<path d="M8,48 L20,42 L32,48 L44,42 L56,48" stroke="#fff" stroke-width="2.5" fill="none" stroke-linejoin="round" stroke-linecap="round"/>' +
    '<path d="M8,62 L20,56 L32,62 L44,56 L56,62" stroke="#fff" stroke-width="2.5" fill="none" stroke-linejoin="round" stroke-linecap="round"/>';

  var PATTERN_HEARTS =
    '<g fill="#fff" opacity="0.95">' +
      '<path d="M22,30 c-2,-2.5 -5,-1 -5,1.5 c0,3 5,6 5,6 c0,0 5,-3 5,-6 c0,-2.5 -3,-4 -5,-1.5 z"/>' +
      '<path d="M42,30 c-2,-2.5 -5,-1 -5,1.5 c0,3 5,6 5,6 c0,0 5,-3 5,-6 c0,-2.5 -3,-4 -5,-1.5 z"/>' +
      '<path d="M32,48 c-2,-2.5 -5,-1 -5,1.5 c0,3 5,6 5,6 c0,0 5,-3 5,-6 c0,-2.5 -3,-4 -5,-1.5 z"/>' +
      '<path d="M22,62 c-1.5,-2 -4,-0.8 -4,1.2 c0,2.4 4,4.8 4,4.8 c0,0 4,-2.4 4,-4.8 c0,-2 -2.5,-3.2 -4,-1.2 z"/>' +
      '<path d="M42,62 c-1.5,-2 -4,-0.8 -4,1.2 c0,2.4 4,4.8 4,4.8 c0,0 4,-2.4 4,-4.8 c0,-2 -2.5,-3.2 -4,-1.2 z"/>' +
    '</g>';

  var PATTERN_STARS =
    '<g fill="#fff" opacity="0.95">' +
      '<g transform="translate(22,30) scale(0.7)"><path d="M0,-5 L1.2,-1.5 L5,-1.5 L2,0.8 L3.2,4.8 L0,2.5 L-3.2,4.8 L-2,0.8 L-5,-1.5 L-1.2,-1.5 Z"/></g>' +
      '<g transform="translate(42,30) scale(0.7)"><path d="M0,-5 L1.2,-1.5 L5,-1.5 L2,0.8 L3.2,4.8 L0,2.5 L-3.2,4.8 L-2,0.8 L-5,-1.5 L-1.2,-1.5 Z"/></g>' +
      '<g transform="translate(32,48) scale(0.95)"><path d="M0,-5 L1.2,-1.5 L5,-1.5 L2,0.8 L3.2,4.8 L0,2.5 L-3.2,4.8 L-2,0.8 L-5,-1.5 L-1.2,-1.5 Z"/></g>' +
      '<g transform="translate(22,64) scale(0.6)"><path d="M0,-5 L1.2,-1.5 L5,-1.5 L2,0.8 L3.2,4.8 L0,2.5 L-3.2,4.8 L-2,0.8 L-5,-1.5 L-1.2,-1.5 Z"/></g>' +
      '<g transform="translate(42,64) scale(0.6)"><path d="M0,-5 L1.2,-1.5 L5,-1.5 L2,0.8 L3.2,4.8 L0,2.5 L-3.2,4.8 L-2,0.8 L-5,-1.5 L-1.2,-1.5 Z"/></g>' +
    '</g>';

  var PATTERN_STRIPES =
    '<path d="M16,34 Q32,35 48,34" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
    '<path d="M12,44 Q32,45 52,44" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
    '<path d="M12,54 Q32,54 52,54" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
    '<path d="M16,64 Q32,64 48,64" stroke="#fff" stroke-width="2.5" fill="none" stroke-linecap="round"/>';

  // 6 варіантів кольорів + візерунків
  var EGG_VARIANTS = [
    buildEggSvg('#fff5fa', '#f7c6d9', '#d68fa9', '#b56a87', PATTERN_FLOWERS),   // 1 рожеве з квітами
    buildEggSvg('#e0f0ff', '#89b9e8', '#4a7ec7', '#2c5aa0', PATTERN_DOTS),       // 2 синє в горошок
    buildEggSvg('#fffae0', '#ffd96a', '#cc9900', '#8a6600', PATTERN_CHEVRONS),   // 3 жовте з шевронами
    buildEggSvg('#e0f8ec', '#85d4a8', '#3d9a5e', '#1e5e38', PATTERN_HEARTS),     // 4 м'ятне з сердечками
    buildEggSvg('#f0e0ff', '#b892e0', '#7b4baa', '#4d2b6e', PATTERN_STARS),      // 5 лавандове з зірками
    buildEggSvg('#ffeadd', '#ffb07a', '#d66b2f', '#8f4210', PATTERN_STRIPES)     // 6 персикове зі смугами
  ];

  var EGG_SVG_GOLDEN =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 80">' +
      '<defs>' +
        '<radialGradient id="ehGold" cx="35%" cy="30%">' +
          '<stop offset="0%" stop-color="#fffbe0"/>' +
          '<stop offset="35%" stop-color="#ffd700"/>' +
          '<stop offset="80%" stop-color="#b8860b"/>' +
          '<stop offset="100%" stop-color="#8b6508"/>' +
        '</radialGradient>' +
        '<radialGradient id="ehGem" cx="40%" cy="40%">' +
          '<stop offset="0%" stop-color="#fff"/>' +
          '<stop offset="50%" stop-color="#ff6b9d"/>' +
          '<stop offset="100%" stop-color="#a01055"/>' +
        '</radialGradient>' +
      '</defs>' +
      '<path d="M32,6 C14,6 6,30 6,48 C6,66 18,76 32,76 C46,76 58,66 58,48 C58,30 50,6 32,6 Z" fill="url(#ehGold)" stroke="#6b4c00" stroke-width="1"/>' +
      '<path d="M10,30 Q20,22 32,28 Q44,34 54,26" stroke="#fff" stroke-width="1.5" fill="none" opacity="0.9"/>' +
      '<path d="M12,34 Q22,28 32,32 Q42,36 52,30" stroke="#fff8c0" stroke-width="1" fill="none"/>' +
      '<path d="M10,62 Q20,68 32,64 Q44,60 54,66" stroke="#fff" stroke-width="1.5" fill="none" opacity="0.9"/>' +
      '<path d="M12,58 Q22,64 32,60 Q42,56 52,62" stroke="#fff8c0" stroke-width="1" fill="none"/>' +
      '<g transform="translate(32,46)">' +
        '<polygon points="0,-8 7,0 0,8 -7,0" fill="#fff" stroke="#8b6508" stroke-width="0.6"/>' +
        '<polygon points="0,-6 5,0 0,6 -5,0" fill="url(#ehGem)"/>' +
        '<circle cx="-1.5" cy="-1.5" r="1.2" fill="#fff" opacity="0.8"/>' +
      '</g>' +
      '<g fill="#fff">' +
        '<path d="M16,22 L17,24 L19,25 L17,26 L16,28 L15,26 L13,25 L15,24 Z" opacity="0.95"/>' +
        '<path d="M48,22 L49,24 L51,25 L49,26 L48,28 L47,26 L45,25 L47,24 Z" opacity="0.95"/>' +
        '<circle cx="20" cy="70" r="1"/>' +
        '<circle cx="44" cy="70" r="1"/>' +
        '<circle cx="32" cy="14" r="1.2"/>' +
      '</g>' +
      '<ellipse cx="22" cy="18" rx="5" ry="9" fill="#fff" opacity="0.55"/>' +
    '</svg>';

  var _eggUidCounter = 0;
  function injectEggSvg(eggEl) {
    if (eggEl.querySelector('svg')) return;
    _eggUidCounter++;
    var uid = 'e' + _eggUidCounter;
    var isGolden = eggEl.classList.contains('easter-egg--golden');
    if (isGolden) {
      // Замінюємо обидва id щоб уникнути конфліктів з іншими золотими на сторінці
      eggEl.innerHTML = EGG_SVG_GOLDEN
        .replace(/ehGold/g, 'ehGold_' + uid)
        .replace(/ehGem/g, 'ehGem_' + uid);
      return;
    }
    // Звичайне яйце — обираємо варіант за числовою частиною ID (egg-01, egg-02, ...)
    var id = eggEl.getAttribute('data-egg-id') || '';
    var match = id.match(/(\d+)/);
    var idx = match ? (parseInt(match[1], 10) - 1) % EGG_VARIANTS.length : 0;
    if (idx < 0) idx = 0;
    eggEl.innerHTML = EGG_VARIANTS[idx].replace(/EGGID/g, uid);
  }

  // ─── Перевірка чи акція ще активна ──────────────────────────
  var now = Date.now();
  var campaignEnd = new Date(CFG.campaignEnd).getTime();
  var isCampaignActive = now < campaignEnd;

  // ─── Storage layer ──────────────────────────────────────────
  var STORAGE_KEY = 'easterHunt2026';

  function defaultProgress() {
    return {
      foundEggs: [],
      claimedTiers: [],
      goldenFound: false,
      goldenClaimed: false,
      pendingGifts: [],
      welcomeShown: false
    };
  }
  function loadProgress() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultProgress();
      var parsed = JSON.parse(raw);
      return Object.assign(defaultProgress(), parsed);
    } catch (e) {
      return defaultProgress();
    }
  }
  function saveProgress(p) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(p)); } catch (e) {}
  }

  var progress = loadProgress();

  // ─── Cart API wrapper ───────────────────────────────────────
  function cartGet() {
    // Cache-busting щоб завжди отримувати актуальний стан кошика
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function cartAdd(variantId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties || {} })
    }).then(function (r) { return r.json(); });
  }
  function cartChangeQty(lineKey, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // ─── Campaign cleanup ───────────────────────────────────────
  function cleanupExpiredCampaign() {
    cartGet().then(function (cart) {
      var giftKeys = (cart.items || [])
        .filter(function (it) { return it.properties && it.properties._easter_gift; })
        .map(function (it) { return it.key; });

      var removeNext = function () {
        if (!giftKeys.length) return;
        cartChangeQty(giftKeys.shift(), 0).then(removeNext);
      };
      removeNext();
    });
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  if (!isCampaignActive) {
    cleanupExpiredCampaign();
    return;
  }

  // ─── DOM helpers ────────────────────────────────────────────
  function el(tag, className, html) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    if (html != null) e.innerHTML = html;
    return e;
  }

  // ─── Modal system ───────────────────────────────────────────
  function showModal(opts) {
    closeModal();
    var overlay = el('div', 'easter-modal');
    overlay.id = 'easter-modal';

    var content = el('div', 'easter-modal__content' + (opts.golden ? ' easter-modal__content--golden' : ''));
    var close = el('button', 'easter-modal__close', '×');
    close.onclick = function () {
      if (opts.onClose) opts.onClose();
      closeModal();
    };
    content.appendChild(close);

    if (opts.emoji) content.appendChild(el('div', 'easter-modal__emoji', opts.emoji));
    if (opts.title) content.appendChild(el('h3', 'easter-modal__title', opts.title));
    if (opts.text)  content.appendChild(el('p', 'easter-modal__text', opts.text));

    if (opts.code) {
      var box = el('div', 'easter-modal__code-box');
      box.appendChild(el('span', 'easter-modal__code', opts.code));
      var copyBtn = el('button', 'easter-modal__copy-btn', 'Копіювати');
      copyBtn.onclick = function () {
        if (navigator.clipboard) navigator.clipboard.writeText(opts.code);
        copyBtn.textContent = 'Скопійовано ✓';
        copyBtn.classList.add('easter-modal__copy-btn--copied');
      };
      box.appendChild(copyBtn);
      content.appendChild(box);
    }

    if (opts.customBody) content.appendChild(opts.customBody);

    if (opts.cta) {
      var cta;
      if (opts.ctaHref) {
        cta = el('a', 'easter-modal__cta', opts.cta);
        cta.href = opts.ctaHref;
      } else {
        cta = el('button', 'easter-modal__cta', opts.cta);
        cta.onclick = function () {
          closeModal();
          if (opts.onCta) opts.onCta();
        };
      }
      content.appendChild(cta);
    }

    overlay.appendChild(content);
    // Закриття по кліку на фон — тільки якщо НЕ welcome модалка
    if (!opts.persistent) {
      overlay.onclick = function (e) { if (e.target === overlay) closeModal(); };
    }
    document.body.appendChild(overlay);
  }
  function closeModal() {
    var m = document.getElementById('easter-modal');
    if (m) m.remove();
  }

  // ─── Counter ────────────────────────────────────────────────
  function renderCounter() {
    var existing = document.getElementById('easter-counter');
    if (existing) existing.remove();

    var found = progress.foundEggs.length;
    var total = CFG.totalEggs;
    var pct = Math.min(100, Math.round((found / total) * 100));

    var counter = el('div', 'easter-counter');
    counter.id = 'easter-counter';
    counter.innerHTML =
      '<div class="easter-counter__title">🥚 ' + CFG.ui.counter.label + ': ' +
        '<b>' + found + ' / ' + total + '</b></div>' +
      '<div class="easter-counter__bar"><div class="easter-counter__bar-fill" style="width:' + pct + '%"></div></div>' +
      '<div class="easter-counter__hint">' + CFG.ui.counter.hint + '</div>';
    // На мобільному — toggle розгортання/згортання по тапу
    counter.addEventListener('click', function () {
      if (window.innerWidth < 768) {
        counter.classList.toggle('easter-counter--expanded');
      }
    });
    document.body.appendChild(counter);
  }
  function bounceCounter() {
    var c = document.getElementById('easter-counter');
    if (!c) return;
    c.classList.add('easter-counter--bounce');
    setTimeout(function () { c.classList.remove('easter-counter--bounce'); }, 600);
  }

  // ─── Egg click logic ────────────────────────────────────────
  function handleEggClick(eggEl) {
    var isGolden = eggEl.classList.contains('easter-egg--golden');
    if (isGolden) {
      handleGoldenEggClick(eggEl);
      return;
    }

    var eggId = eggEl.getAttribute('data-egg-id');
    if (!eggId) return;
    if (progress.foundEggs.indexOf(eggId) !== -1) {
      eggEl.classList.add('easter-egg--found');
      return;
    }

    progress.foundEggs.push(eggId);
    saveProgress(progress);
    eggEl.classList.add('easter-egg--found');
    renderCounter();
    bounceCounter();

    var count = progress.foundEggs.length;
    var tier = findTierAt(count);

    if (tier && progress.claimedTiers.indexOf(tier.threshold) === -1) {
      awardTier(tier);
    } else {
      showProgressModal(count);
    }
  }

  function findTierAt(count) {
    for (var i = 0; i < CFG.tiers.length; i++) {
      if (CFG.tiers[i].threshold === count) return CFG.tiers[i];
    }
    return null;
  }
  function nextTierThreshold(count) {
    for (var i = 0; i < CFG.tiers.length; i++) {
      if (CFG.tiers[i].threshold > count) return CFG.tiers[i].threshold;
    }
    return null;
  }
  function showProgressModal(count) {
    var next = nextTierThreshold(count);
    var text;
    if (next) {
      text = CFG.ui.eggFound.textTemplate
        .replace('{found}', count)
        .replace('{total}', CFG.totalEggs)
        .replace('{toNext}', next - count);
    } else {
      text = CFG.ui.eggFound.textFinal
        .replace('{found}', count)
        .replace('{total}', CFG.totalEggs);
    }
    showModal({
      emoji: CFG.ui.eggFound.emoji,
      title: CFG.ui.eggFound.title,
      text: text,
      cta: CFG.ui.eggFound.cta
    });
  }

  // ─── Prizes ─────────────────────────────────────────────────
  function getVariantsForTier(tier) {
    if (tier.variants && tier.variants.length) {
      return tier.variants.filter(function (v) { return v && v.id; }); // фільтруємо незаповнені
    }
    if (tier.useVariantsFromTier) {
      var src = CFG.tiers.find(function (t) { return t.threshold === tier.useVariantsFromTier; });
      if (src && src.variants) {
        return src.variants.filter(function (v) { return v && v.id; });
      }
    }
    return [];
  }

  function awardTier(tier) {
    progress.claimedTiers.push(tier.threshold);
    saveProgress(progress);

    if (tier.type === 'promo') awardPromo(tier);
    else if (tier.type === 'gift_with_color') awardGiftWithColor(tier);
    else if (tier.type === 'gift_plus_promo') awardGiftPlusPromo(tier);
    else if (tier.type === 'gift_multi_plus_promo') awardGiftMultiPlusPromo(tier);
  }

  function awardPromo(tier) {
    showModal({
      emoji: tier.modal.emoji,
      title: tier.modal.title,
      text: tier.modal.text,
      code: tier.code,
      cta: tier.modal.cta,
      onCta: function () {
        applyPromoWithFeedback(tier.code, !!tier.isFinal);
      }
    });
  }

  function awardGiftWithColor(tier) {
    var variants = getVariantsForTier(tier);
    if (!variants.length) {
      console.warn('[EasterHunt] No variants configured for tier', tier.threshold);
      if (CFG.debug) {
        showModal({
          emoji: '⚠️',
          title: 'DEV: variants порожні',
          text: 'У <b>easter-config.liquid</b> → tier ' + tier.threshold + ' → поле <b>variants</b> пусте. Заповни ID варіантів пов\'язки після створення товару-подарунка.',
          cta: 'Добре'
        });
      } else {
        showModal({
          emoji: '🎁',
          title: 'Приз зарезервовано!',
          text: 'Твій подарунок уже на тебе чекає — ми додамо його до замовлення після оформлення. Приємних свят!',
          cta: 'Дякую'
        });
      }
      return;
    }

    var grid = el('div', 'easter-color-grid');
    variants.forEach(function (v) {
      var swatch = el('div', 'easter-color-swatch');
      swatch.style.background = v.hex || '#ccc';
      swatch.title = v.color;
      swatch.appendChild(el('span', 'easter-color-swatch__label', v.color));
      swatch.onclick = function () {
        closeModal();
        addGiftOrPend(v.id, tier.threshold).then(function (result) {
          if (result.pending) {
            showModal({
              emoji: '🎁',
              title: 'Подарунок зарезервовано!',
              text: 'Пов\'язка (<b>' + v.color + '</b>) з\'явиться в кошику автоматично, щойно ти додаш будь-який товар.',
              cta: 'Продовжити пошук 🔍'
            });
          } else {
            showModal({
              emoji: '🎁',
              title: 'Подарунок у кошику!',
              text: 'Пов\'язка (<b>' + v.color + '</b>) додана до кошика.',
              cta: 'Продовжити пошук 🔍'
            });
          }
        });
      };
      grid.appendChild(swatch);
    });

    showModal({
      emoji: tier.modal.emoji,
      title: tier.modal.title,
      text: tier.modal.text,
      customBody: grid
    });
  }

  function awardGiftPlusPromo(tier) {
    if (!tier.giftVariantId) {
      console.warn('[EasterHunt] No gift variant for final tier');
      if (CFG.debug) {
        showModal({
          emoji: '⚠️',
          title: 'DEV: giftVariantId порожній',
          text: 'У <b>easter-config.liquid</b> → tier ' + tier.threshold + ' → поле <b>giftVariantId</b> = null. Заповни variant_id набору пов\'язок після створення товару-подарунка.',
          cta: 'Добре'
        });
      } else {
        // Prod fallback — без подарунка, але з промокодом
        showModal({
          emoji: tier.modal.emoji,
          title: tier.modal.title,
          text: tier.modal.text,
          code: tier.code,
          cta: tier.modal.cta,
          onCta: function () {
            applyPromoWithFeedback(tier.code);
          }
        });
      }
      return;
    }
    addGiftToCart(tier.giftVariantId, tier.threshold).then(function () {
      showModal({
        emoji: tier.modal.emoji,
        title: tier.modal.title,
        text: tier.modal.text,
        code: tier.code,
        cta: tier.modal.cta,
        onCta: function () {
          applyPromoWithFeedback(tier.code);
        }
      });
    });
  }

  function awardGiftMultiPlusPromo(tier) {
    var variants = getVariantsForTier(tier);
    var needed = tier.setSize || 3;

    if (variants.length < needed) {
      console.warn('[EasterHunt] Not enough variants for multi tier', tier.threshold);
      if (CFG.debug) {
        showModal({
          emoji: '⚠️',
          title: 'DEV: не вистачає variants',
          text: 'Для tier ' + tier.threshold + ' потрібно мінімум ' + needed + ' варіантів. Зараз заповнено: ' + variants.length + '.',
          cta: 'Добре'
        });
      } else {
        // Prod fallback — тільки промокод
        showModal({
          emoji: tier.modal.emoji,
          title: tier.modal.title,
          text: 'Твій фінальний приз — знижка <b>15%</b>. Тисни кнопку, щоб застосувати.',
          code: tier.code,
          cta: tier.modal.cta,
          onCta: function () { applyPromoWithFeedback(tier.code); }
        });
      }
      return;
    }

    var selected = []; // масив variant id
    var swatches = []; // для доступу з обробника

    var grid = el('div', 'easter-color-grid');
    variants.forEach(function (v) {
      var swatch = el('div', 'easter-color-swatch');
      swatch.style.background = v.hex || '#ccc';
      swatch.title = v.color;
      swatch.appendChild(el('span', 'easter-color-swatch__label', v.color));
      swatch.dataset.variantId = v.id;

      swatch.onclick = function () {
        var idx = selected.indexOf(v.id);
        if (idx >= 0) {
          selected.splice(idx, 1);
          swatch.classList.remove('easter-color-swatch--selected');
        } else if (selected.length < needed) {
          selected.push(v.id);
          swatch.classList.add('easter-color-swatch--selected');
        }
        updateCounter();
      };

      grid.appendChild(swatch);
      swatches.push(swatch);
    });

    var counter = el('div', 'easter-set-counter');
    var confirmBtn = el('button', 'easter-modal__cta', 'Додати до кошика');
    confirmBtn.disabled = true;
    confirmBtn.style.marginTop = '16px';

    function updateCounter() {
      counter.innerHTML = 'Обрано: <b>' + selected.length + ' з ' + needed + '</b>';
      confirmBtn.disabled = selected.length !== needed;
      confirmBtn.style.opacity = confirmBtn.disabled ? '0.5' : '1';
      confirmBtn.style.cursor = confirmBtn.disabled ? 'not-allowed' : 'pointer';
    }
    updateCounter();

    confirmBtn.onclick = function () {
      if (selected.length !== needed) return;
      closeModal();
      // Перевіряємо чи є реальний товар в кошику
      hasRealItems().then(function (hasReal) {
        if (hasReal) {
          // Спершу видаляємо стару повязку з tier 7 (замінюємо на набір з 3)
          removeGiftsByTier(7).then(function () {
            // Додаємо 3 пов'язки ПОСЛІДОВНО
            var chain = Promise.resolve();
            selected.forEach(function (vid) {
              chain = chain.then(function () { return addGiftToCart(vid, tier.threshold); });
            });
            return chain;
          }).then(function () {
            var finalMsg = (tier.finalText || '');
            showModal({
              emoji: tier.modal.emoji,
              title: 'Усі 3 пов\'язки у кошику!',
              text: (finalMsg ? finalMsg + '<br><br>' : '') + 'А ще ось твій промокод на знижку <b>15%</b>:',
              code: tier.code,
              cta: 'Дякую! 💛',
              onCta: function () { applyPromoWithFeedback(tier.code, true); }
            });
          });
        } else {
          // Кошик порожній — зберігаємо як pending + видаляємо tier-7 повязку (замінюється набором)
          if (!progress.pendingGifts) progress.pendingGifts = [];
          progress.pendingGifts = progress.pendingGifts.filter(function (g) { return String(g.tier) !== '7'; });
          selected.forEach(function (vid) {
            progress.pendingGifts.push({ variantId: vid, tier: tier.threshold });
          });
          saveProgress(progress);
          var finalMsg = (tier.finalText || '');
          var finalMsg2 = (tier.finalText || '');
          showModal({
            emoji: tier.modal.emoji,
            title: 'Подарунки зарезервовано!',
            text: (finalMsg2 ? finalMsg2 + '<br><br>' : '') + '3 пов\'язки з\'являться у кошику, щойно ти додаш будь-який товар. А ось твій промокод:',
            code: tier.code,
            cta: 'Дякую! 💛',
            onCta: function () { applyPromoWithFeedback(tier.code, true); }
          });
        }
      });
    };

    var body = el('div');
    body.appendChild(grid);
    body.appendChild(counter);
    body.appendChild(confirmBtn);

    showModal({
      emoji: tier.modal.emoji,
      title: tier.modal.title,
      text: tier.modal.text + '<br><br>Обери <b>' + needed + '</b> кольори пов\'язок нижче:',
      customBody: body
    });
  }

  function addGiftToCart(variantId, tierThreshold) {
    return cartAdd(variantId, {
      _easter_gift: 'true',
      _easter_tier: String(tierThreshold)
    }).then(function (resp) {
      if (resp && resp.status && resp.status >= 400) {
        console.error('[EasterHunt] Cart add error:', resp.description || resp.message);
        return null;
      }
      refreshCartUI();
      return resp;
    }).catch(function (err) {
      console.error('[EasterHunt] Failed to add gift', err);
      return null;
    });
  }

  // Оновлення лічильника кошика в хедері теми
  function refreshCartUI() {
    cartGet().then(function (cart) {
      var count = cart.item_count || 0;
      // Шукаємо всі можливі елементи з кількістю товарів
      document.querySelectorAll('a[href="/cart"]').forEach(function (link) {
        var spans = link.querySelectorAll('span');
        spans.forEach(function (s) { if (s.textContent.match(/^\d+$/)) s.textContent = count; });
      });
      document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]').forEach(function (b) {
        b.textContent = count;
      });
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      } catch (e) {}
    });
  }

  // Видалити з кошика всі подарунки з певним tier
  function removeGiftsByTier(tierValue) {
    return cartGet().then(function (cart) {
      var toRemove = (cart.items || []).filter(function (it) {
        return it.properties && it.properties._easter_gift && it.properties._easter_tier === String(tierValue);
      });
      var chain = Promise.resolve();
      toRemove.forEach(function (item) {
        chain = chain.then(function () { return cartChangeQty(item.key, 0); });
      });
      return chain;
    });
  }

  // Перевірка чи є в кошику хоча б один реальний (платний) товар
  function hasRealItems() {
    return cartGet().then(function (cart) {
      if (!cart || !cart.items) return false;
      return cart.items.some(function (it) {
        return !(it.properties && it.properties._easter_gift) && it.price > 0;
      });
    });
  }

  // Додати подарунок або зберегти як pending (якщо кошик порожній)
  function addGiftOrPend(variantId, tierThreshold) {
    return hasRealItems().then(function (hasReal) {
      if (hasReal) {
        return addGiftToCart(variantId, tierThreshold).then(function () { return { added: true }; });
      } else {
        if (!progress.pendingGifts) progress.pendingGifts = [];
        progress.pendingGifts.push({ variantId: variantId, tier: tierThreshold });
        saveProgress(progress);
        return { added: false, pending: true };
      }
    });
  }

  // При завантаженні сторінки: якщо є pending gifts і кошик має реальні товари — додаємо ВСІ + reload
  function processPendingGifts() {
    if (!progress.pendingGifts || !progress.pendingGifts.length) return;
    hasRealItems().then(function (hasReal) {
      if (!hasReal) return;
      var pending = progress.pendingGifts.slice();

      // Якщо є tier-15 подарунки — не додаємо tier-7 (замінено набором з 3)
      var hasTier15 = pending.some(function (g) { return String(g.tier) === '15'; });
      if (hasTier15) {
        pending = pending.filter(function (g) { return String(g.tier) !== '7'; });
      }

      progress.pendingGifts = [];
      saveProgress(progress);

      // Додаємо всі послідовно
      var chain = Promise.resolve();
      pending.forEach(function (g) {
        chain = chain.then(function () { return addGiftToCart(g.variantId, g.tier); });
      });
      // Після додавання ВСІХ — перезавантажуємо сторінку щоб корзина оновилась
      chain.then(function () {
        location.reload();
      });
    });
  }

  // Якщо з кошика видалили всі реальні товари — переносимо подарунки назад у pending
  function cleanupGiftsIfNoRealItems() {
    cartGet().then(function (cart) {
      if (!cart || !cart.items) return;
      var gifts = cart.items.filter(function (it) { return it.properties && it.properties._easter_gift; });
      var real = cart.items.filter(function (it) { return !(it.properties && it.properties._easter_gift) && it.price > 0; });
      if (gifts.length > 0 && real.length === 0) {
        // Зберігаємо подарунки назад у pending — повернуться коли додадуть товар
        if (!progress.pendingGifts) progress.pendingGifts = [];
        gifts.forEach(function (g) {
          var tier = (g.properties && g.properties._easter_tier) || 'unknown';
          // Не дублюємо якщо вже є в pending
          var exists = progress.pendingGifts.some(function (p) {
            return p.variantId === g.variant_id && String(p.tier) === String(tier);
          });
          if (!exists) {
            progress.pendingGifts.push({ variantId: g.variant_id, tier: tier });
          }
        });
        saveProgress(progress);

        // Видаляємо з кошика
        var chain = Promise.resolve();
        gifts.forEach(function (g) {
          chain = chain.then(function () { return cartChangeQty(g.key, 0); });
        });
        chain.then(function () { refreshCartUI(); });
      }
    });
  }

  // ─── Apply promo code in background + open cart drawer ─────
  function applyPromoCode(code) {
    // Крок 1: скидаємо поточний промокод (через cart update з порожнім discount)
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () {
      // Крок 2: застосовуємо новий
      return fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        method: 'GET'
      });
    }).then(function () {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).catch(function (err) {
      console.error('[EasterHunt] Promo apply failed:', err);
      return null;
    });
  }

  function applyPromoWithFeedback(code, isFinal) {
    var note = '<br><br><span style="font-size:12px;color:#999;">Промокод не сумується з акційними товарами та діє лише на повну вартість.</span>';
    var text = isFinal
      ? 'Код <b>' + code + '</b> активний і застосується при оформленні замовлення.' + note
      : 'Код <b>' + code + '</b> активний і застосується при оформленні. Продовжуй шукати — попереду ще більше подарунків!' + note;
    showModal({
      emoji: '✅',
      title: 'Промокод застосовано!',
      text: text,
      cta: isFinal ? 'Дякую! 💛' : 'Продовжити пошук 🔍'
    });
    applyPromoCode(code).then(function () {
      refreshCartUI();
    });
  }

  // ─── Golden egg ─────────────────────────────────────────────
  function handleGoldenEggClick(eggEl) {
    var searchWrap = eggEl.closest ? eggEl.closest('.easter-search-golden') : null;

    if (progress.goldenFound) {
      eggEl.classList.add('easter-egg--found');
      if (searchWrap) searchWrap.remove();
      return;
    }
    progress.goldenFound = true;
    saveProgress(progress);
    eggEl.classList.add('easter-egg--found');
    if (searchWrap) searchWrap.remove();

    if (CFG.golden.type === 'gift_multi') {
      awardGoldenMulti();
    } else {
      showModal({ golden: true, emoji: CFG.golden.modal.emoji, title: CFG.golden.modal.title, text: CFG.golden.modal.text, cta: 'Продовжити пошук 🔍' });
    }
  }

  function awardGoldenMulti() {
    var variants = getVariantsForTier(CFG.golden);
    var needed = CFG.golden.setSize || 3;

    if (!variants.length) {
      if (CFG.debug) {
        showModal({ emoji: '⚠️', title: 'DEV: variants порожні для golden', text: 'Заповни variants або useVariantsFromTier.', cta: 'Добре' });
      }
      return;
    }

    var selected = [];
    var grid = el('div', 'easter-color-grid');
    variants.forEach(function (v) {
      var swatch = el('div', 'easter-color-swatch');
      swatch.style.background = v.hex || '#ccc';
      swatch.title = v.color;
      swatch.appendChild(el('span', 'easter-color-swatch__label', v.color));
      swatch.onclick = function () {
        var idx = selected.indexOf(v.id);
        if (idx >= 0) {
          selected.splice(idx, 1);
          swatch.classList.remove('easter-color-swatch--selected');
        } else if (selected.length < needed) {
          selected.push(v.id);
          swatch.classList.add('easter-color-swatch--selected');
        }
        counter.innerHTML = 'Обрано: <b>' + selected.length + ' з ' + needed + '</b>';
        confirmBtn.disabled = selected.length !== needed;
        confirmBtn.style.opacity = confirmBtn.disabled ? '0.5' : '1';
        confirmBtn.style.cursor = confirmBtn.disabled ? 'not-allowed' : 'pointer';
      };
      grid.appendChild(swatch);
    });

    var counter = el('div', 'easter-set-counter', 'Обрано: <b>0 з ' + needed + '</b>');
    var confirmBtn = el('button', 'easter-modal__cta', 'Додати до кошика');
    confirmBtn.disabled = true;
    confirmBtn.style.marginTop = '16px';
    confirmBtn.style.opacity = '0.5';
    confirmBtn.style.cursor = 'not-allowed';

    confirmBtn.onclick = function () {
      if (selected.length !== needed) return;
      closeModal();
      progress.goldenClaimed = true;
      saveProgress(progress);

      hasRealItems().then(function (hasReal) {
        if (hasReal) {
          removeGiftsByTier(7).then(function () {
            var chain = Promise.resolve();
            selected.forEach(function (vid) {
              chain = chain.then(function () { return addGiftToCart(vid, 'golden'); });
            });
            return chain;
          }).then(function () {
            showModal({ golden: true, emoji: CFG.golden.modalAfterAdd.emoji, title: CFG.golden.modalAfterAdd.title, text: CFG.golden.modalAfterAdd.text, cta: CFG.golden.modalAfterAdd.cta });
          });
        } else {
          if (!progress.pendingGifts) progress.pendingGifts = [];
          progress.pendingGifts = progress.pendingGifts.filter(function (g) { return String(g.tier) !== '7'; });
          selected.forEach(function (vid) {
            progress.pendingGifts.push({ variantId: vid, tier: 'golden' });
          });
          saveProgress(progress);
          showModal({ golden: true, emoji: CFG.golden.modalPending.emoji, title: CFG.golden.modalPending.title, text: CFG.golden.modalPending.text, cta: CFG.golden.modalPending.cta });
        }
      });
    };

    var body = el('div');
    body.appendChild(grid);
    body.appendChild(counter);
    body.appendChild(confirmBtn);

    showModal({ golden: true, emoji: CFG.golden.modal.emoji, title: CFG.golden.modal.title, text: CFG.golden.modal.text, customBody: body });
  }

  // ─── Search page: golden egg for "великдень" ────────────────
  function checkSearchPageForGolden() {
    if (!location.pathname.includes('/search')) return;
    if (progress.goldenFound) return; // вже знайшли — не показуємо взагалі

    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').toLowerCase().trim();
    var triggers = ['великдень', 'великодн', 'паска', 'пасха', 'easter'];
    var matched = triggers.some(function (t) { return q.indexOf(t) !== -1; });
    if (!matched) return;

    var container = document.querySelector('main, #MainContent, .main-content, body');
    if (!container) return;

    var wrap = el('div', 'easter-search-golden');
    wrap.style.cssText = 'text-align:center;padding:40px 20px;';
    wrap.innerHTML = '<p style="color:#888;font-size:13px;">А ти вмієш шукати...</p>';

    var egg = el('span', 'easter-egg easter-egg--golden');
    egg.setAttribute('data-egg-id', 'golden-search');
    egg.style.display = 'inline-block';
    wrap.appendChild(egg);
    injectEggSvg(egg);

    container.insertBefore(wrap, container.firstChild);
  }

  // ─── 404 page golden egg ──────────────────────────────────
  function check404ForGolden() {
    if (progress.goldenFound) return;
    // Shopify 404 сторінки мають клас template-404 на body або специфічний текст
    var is404 = document.body.classList.contains('template-404') ||
      document.querySelector('.shopify-section--404') ||
      (document.title && document.title.indexOf('404') !== -1) ||
      document.querySelector('[class*="404"]');
    if (!is404) return;

    var container = document.querySelector('main, #MainContent, .main-content, body');
    if (!container) return;

    var wrap = el('div', 'easter-search-golden');
    wrap.style.cssText = 'text-align:center;padding:40px 20px;';
    wrap.innerHTML = '<p style="color:#888;font-size:13px;">Загубилось? Може, це доля...</p>';
    var egg = el('span', 'easter-egg easter-egg--golden');
    egg.setAttribute('data-egg-id', 'golden-404');
    egg.style.display = 'inline-block';
    wrap.appendChild(egg);
    injectEggSvg(egg);
    container.appendChild(wrap);
  }

  // ─── Product accordion golden egg (при розкритті "Параметри моделі") ─
  function checkProductTabForGolden() {
    if (progress.goldenFound) return;
    if (location.pathname.indexOf('mesh-bandeau-bodysuit-with-shoulder-draping-in-powder-pink') === -1) return;

    // Шукаємо акордеон з текстом "Параметри моделі"
    var accordions = document.querySelectorAll('details.accordion');
    var target = null;
    accordions.forEach(function (acc) {
      var summary = acc.querySelector('summary');
      if (summary && summary.textContent.indexOf('Параметри') !== -1) target = acc;
    });
    if (!target) return;

    var handled = false;
    target.addEventListener('toggle', function () {
      if (handled || progress.goldenFound || !target.open) return;
      handled = true;
      setTimeout(function () {
        var content = target.querySelector('.accordion__content');
        if (!content) content = target;
        var egg = el('span', 'easter-egg easter-egg--golden');
        egg.setAttribute('data-egg-id', 'golden-tab');
        egg.style.display = 'block';
        egg.style.margin = '16px auto';
        content.appendChild(egg);
        injectEggSvg(egg);
      }, 200);
    });
  }

  // ─── Sort dropdown golden egg (з'являється при відкритті) ──
  function checkSortForGolden() {
    if (progress.goldenFound) return;
    // Тільки на сторінці "Переглянути все" (/collections/all)
    if (location.pathname.indexOf('/collections/all') === -1) return;

    var sortToggle = document.querySelector('.popout--sort .popout__toggle');
    if (!sortToggle) return;

    var handled = false;
    sortToggle.addEventListener('click', function () {
      if (handled || progress.goldenFound) return;
      handled = true;
      setTimeout(function () {
        var list = document.querySelector('.popout--sort .popout-list');
        if (!list) return;
        // Додаємо золоте яйце як останній пункт списку
        var li = document.createElement('li');
        li.className = 'popout-list__item';
        li.style.textAlign = 'center';
        li.style.padding = '12px 0';
        var egg = el('span', 'easter-egg easter-egg--golden');
        egg.setAttribute('data-egg-id', 'golden-sort');
        egg.style.display = 'inline-block';
        li.appendChild(egg);
        injectEggSvg(egg);
        list.appendChild(li);
      }, 200);
    });
  }

  // ─── Egg placement by CSS selector ──────────────────────────
  function placeEggsBySelector() {
    var placements = CFG.eggPlacements || [];
    var currentPath = location.pathname;
    placements.forEach(function (p) {
      // Вже розмістили? — пропускаємо (може бути в rich text)
      if (document.querySelector('[data-egg-id="' + p.id + '"]')) return;

      // URL фільтр — яйце з'являється тільки якщо поточна сторінка збігається
      if (p.urlMatch && currentPath.indexOf(p.urlMatch) === -1) return;

      var target = document.querySelector(p.selector);
      if (!target) {
        if (CFG.debug) console.log('[EasterHunt] Placement skipped — selector not found:', p.selector, '(id:', p.id + ')');
        return;
      }

      var egg = document.createElement('span');
      egg.className = 'easter-egg' + (p.golden ? ' easter-egg--golden' : '');
      egg.setAttribute('data-egg-id', p.id);
      egg.setAttribute('role', 'button');
      egg.setAttribute('tabindex', '0');
      egg.setAttribute('aria-label', 'Пасхальне яйце');

      // За замовчуванням — absolute positioning (яйце "налипає" в куток секції
      // і не займає місця в потоці документа). Вимкнути можна через absolute: false.
      var useAbsolute = p.absolute !== false;

      if (useAbsolute) {
        var computed = getComputedStyle(target);
        if (computed.position === 'static') {
          target.style.position = 'relative';
        }
        // НЕ ставимо overflow:hidden — на мобільному воно обрізає яйця
        egg.style.position = 'absolute';
        egg.style.zIndex = '10';

        var isMobile = window.innerWidth < 768;
        var pos = (typeof p.absolute === 'object' && p.absolute) ? p.absolute : { top: '16px', right: '16px' };
        // На мобільному: зводимо позиції до безпечних зон (не далі 80% по ширині)
        var mobilePos = (typeof p.absoluteMobile === 'object' && p.absoluteMobile) ? p.absoluteMobile : null;
        if (isMobile && mobilePos) {
          pos = mobilePos;
        } else if (isMobile) {
          // Автоматична корекція: замінюємо великі left% на right, і навпаки
          if (pos.left && pos.left.indexOf('%') !== -1 && parseInt(pos.left) > 60) {
            pos = { top: pos.top || pos.bottom || '20px', right: '12px' };
          }
        }
        if (pos.top    !== undefined) egg.style.top    = pos.top;
        if (pos.right  !== undefined) egg.style.right  = pos.right;
        if (pos.bottom !== undefined) egg.style.bottom = pos.bottom;
        if (pos.left   !== undefined) egg.style.left   = pos.left;
        target.appendChild(egg);
      } else {
        // Inline mode — стара поведінка (яйце між текстом)
        egg.style.display = 'inline-block';
        if (p.marginLeft)  egg.style.marginLeft  = p.marginLeft;
        if (p.marginRight) egg.style.marginRight = p.marginRight;

        if (p.method === 'prepend') {
          target.insertBefore(egg, target.firstChild);
        } else if (p.method === 'before') {
          target.parentNode.insertBefore(egg, target);
        } else if (p.method === 'after') {
          target.parentNode.insertBefore(egg, target.nextSibling);
        } else {
          target.appendChild(egg);
        }
      }

      injectEggSvg(egg);
    });
  }

  // ─── Mark already-found eggs & inject SVG in existing ones ─
  function markFoundEggs() {
    document.querySelectorAll('.easter-egg').forEach(function (eggEl) {
      injectEggSvg(eggEl); // на випадок якщо яйце з rich text paste без SVG
      var id = eggEl.getAttribute('data-egg-id');
      if (!id) return;
      if (progress.foundEggs.indexOf(id) !== -1) {
        eggEl.classList.add('easter-egg--found');
      }
      if (eggEl.classList.contains('easter-egg--golden') && progress.goldenFound) {
        eggEl.classList.add('easter-egg--found');
      }
    });
  }

  // ─── Cart page — моніторинг + захист ────────────────────────
  var _lastCartHash = '';
  var _isCleaningCart = false;

  function handleCartPage() {
    if (!location.pathname.match(/^\/cart\/?$/)) return;

    // Перевіряємо одразу і кожну секунду
    checkCartState();
    setInterval(checkCartState, 1000);

    // Перехоплюємо клік на checkout — якщо тільки подарунки, блокуємо
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[name="checkout"], [href*="/checkout"], .cart__checkout-button, .cart__submit');
      if (!btn) return;
      if (_lastCartHash === 'gifts-only') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showModal({
          emoji: '🐰',
          title: 'Додай хоча б один товар',
          text: 'Для отримання подарунків у кошику має бути принаймні один товар із каталогу.',
          cta: 'До каталогу',
          ctaHref: '/collections/all'
        });
        return false;
      }
    }, true);

    // Слухаємо зміни в DOM кошика (ловимо AJAX-видалення швидше ніж polling)
    var cartContainer = document.querySelector('form[action="/cart"], #cart, .cart, main');
    if (cartContainer) {
      var observer = new MutationObserver(function () {
        if (!_isCleaningCart) checkCartState();
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    }
  }

  function checkCartState() {
    if (_isCleaningCart) return; // запобігаємо паралельним cleanup
    cartGet().then(function (cart) {
      var items = cart.items || [];
      var gifts = items.filter(function (it) { return it.properties && it.properties._easter_gift; });
      var real = items.filter(function (it) { return !(it.properties && it.properties._easter_gift) && it.price > 0; });

      if (gifts.length > 0 && real.length === 0) {
        _lastCartHash = 'gifts-only';
        _isCleaningCart = true;

        // Зберігаємо подарунки в pending — повернуться з новим товаром
        if (!progress.pendingGifts) progress.pendingGifts = [];
        gifts.forEach(function (g) {
          var tier = (g.properties && g.properties._easter_tier) || 'unknown';
          var exists = progress.pendingGifts.some(function (p) {
            return p.variantId === g.variant_id && String(p.tier) === String(tier);
          });
          if (!exists) {
            progress.pendingGifts.push({ variantId: g.variant_id, tier: tier });
          }
        });
        saveProgress(progress);

        // Видаляємо з кошика
        var chain = Promise.resolve();
        gifts.forEach(function (g) {
          chain = chain.then(function () { return cartChangeQty(g.key, 0); });
        });
        chain.then(function () {
          _isCleaningCart = false;
          location.reload();
        }).catch(function () {
          _isCleaningCart = false;
        });
      } else if (items.length === 0) {
        _lastCartHash = 'empty';
      } else {
        _lastCartHash = 'ok';
      }
    });
  }

  // ─── Welcome modal ──────────────────────────────────────────
  function showWelcomeIfNeeded() {
    if (!CFG.welcome || !CFG.welcome.enabled) return;
    if (progress.welcomeShown) return;

    // НЕ ставимо welcomeShown тут — тільки коли юзер ЯВНО закриє (кнопка або хрестик)

    var ladderItems = (CFG.welcome.ladder || []).map(function (item) {
      return '<li style="margin:8px 0;padding-left:4px;">' + item + '</li>';
    }).join('');

    var body = el('div');
    body.style.textAlign = 'left';
    body.innerHTML =
      '<p style="margin:0 0 20px;font-size:15px;line-height:1.5;color:#555;text-align:center;">' + CFG.welcome.intro + '</p>' +
      '<p style="margin:20px 0 10px;font-weight:700;color:#333;">' + CFG.welcome.ladderTitle + '</p>' +
      '<ul style="list-style:none;padding:0;margin:0 0 24px;font-size:14px;color:#555;">' + ladderItems + '</ul>' +
      '<p style="margin:0 0 28px;padding:14px 16px;background:#fff9e0;border-radius:10px;font-size:13px;line-height:1.5;color:#8a6d00;">' + CFG.welcome.bonus + '</p>';

    showModal({
      emoji: CFG.welcome.emoji,
      title: CFG.welcome.title,
      customBody: body,
      cta: CFG.welcome.cta,
      persistent: true,
      onCta: function () {
        progress.welcomeShown = true;
        saveProgress(progress);
      },
      onClose: function () {
        progress.welcomeShown = true;
        saveProgress(progress);
      }
    });
  }

  // ─── Блокуємо посилання + кількість подарункових товарів ────
  function blockGiftLinks() {
    // Блокуємо посилання на подарункові товари
    document.querySelectorAll('a[href*="easter-gift"]').forEach(function (link) {
      if (link._easterBlocked) return;
      link._easterBlocked = true;
      link.style.pointerEvents = 'none';
      link.style.textDecoration = 'none';
      link.style.cursor = 'default';
      link.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
    });

    // Знаходимо рядки подарунків і блокуємо кнопки +/- та інпут
    document.querySelectorAll('[href*="easter-gift"]').forEach(function (link) {
      var row = link.closest('[data-cart-item], .cart__item, .cart-item, form, tr');
      if (!row) {
        // Піднімаємось вручну до рівня де є кнопки
        var p = link;
        for (var i = 0; i < 10; i++) { p = p.parentElement; if (!p) break; if (p.querySelector('.cart__quantity-minus')) { row = p; break; } }
      }
      if (!row) return;

      // Блокуємо конкретні кнопки теми
      row.querySelectorAll('.cart__quantity-minus, .cart__quantity-plus').forEach(function (btn) {
        btn.disabled = true;
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.3';
        btn.style.cursor = 'not-allowed';
      });
      row.querySelectorAll('.cart__quantity-field').forEach(function (inp) {
        inp.setAttribute('readonly', 'readonly');
        inp.style.pointerEvents = 'none';
        inp.style.opacity = '0.5';
      });
    });

    // Додаткова перевірка через API — якщо якось вдалось змінити кількість
    cartGet().then(function (cart) {
      if (!cart || !cart.items) return;
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._easter_gift && item.quantity > 1) {
          cartChangeQty(item.key, 1).then(function () { refreshCartUI(); });
        }
      });
    });
  }
  // Якщо юзер відкрив прямий URL подарункового товару — редірект
  if (location.pathname.indexOf('easter-gift') !== -1) {
    location.replace('/');
  }

  blockGiftLinks();
  setInterval(blockGiftLinks, 800);

  // ─── Глобальний перехоплювач змін кошика ─────────────────────
  // Monkey-patch fetch/XHR щоб ловити ВСІ зміни кошика на будь-якій сторінці
  // (включно з drawer, quick-add, AJAX remove тощо)
  var _cartCheckTimeout = null;
  function scheduleCartCheck() {
    if (_cartCheckTimeout) clearTimeout(_cartCheckTimeout);
    _cartCheckTimeout = setTimeout(function () {
      _cartCheckTimeout = null;
      globalCartCheck();
    }, 150); // мінімальна затримка
  }

  function globalCartCheck() {
    cartGet().then(function (cart) {
      if (!cart || !cart.items) return;
      var gifts = cart.items.filter(function (it) { return it.properties && it.properties._easter_gift; });
      var real = cart.items.filter(function (it) { return !(it.properties && it.properties._easter_gift) && it.price > 0; });

      // Є подарунки але нема платних товарів → переносимо в pending + видаляємо
      if (gifts.length > 0 && real.length === 0) {
        if (!progress.pendingGifts) progress.pendingGifts = [];
        gifts.forEach(function (g) {
          var tier = (g.properties && g.properties._easter_tier) || 'unknown';
          var exists = progress.pendingGifts.some(function (p) {
            return p.variantId === g.variant_id && String(p.tier) === String(tier);
          });
          if (!exists) {
            progress.pendingGifts.push({ variantId: g.variant_id, tier: tier });
          }
        });
        saveProgress(progress);
        var chain = Promise.resolve();
        gifts.forEach(function (g) {
          chain = chain.then(function () { return cartChangeQty(g.key, 0); });
        });
        chain.then(function () { location.reload(); });
        return;
      }

      // Є pending подарунки і є платний товар → додаємо pending
      if (progress.pendingGifts && progress.pendingGifts.length > 0 && real.length > 0) {
        processPendingGifts();
      }

      refreshCartUI();
    });
  }

  // Перехоплюємо fetch
  var _origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartChange = url.indexOf('/cart/add') !== -1 ||
                       url.indexOf('/cart/change') !== -1 ||
                       url.indexOf('/cart/update') !== -1 ||
                       url.indexOf('/cart/clear') !== -1;
    if (isCartChange) {
      return _origFetch.apply(this, arguments).then(function (response) {
        scheduleCartCheck();
        return response;
      });
    }
    return _origFetch.apply(this, arguments);
  };

  // Перехоплюємо XMLHttpRequest (для старих тем/додатків)
  var _origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
      this.addEventListener('load', function () { scheduleCartCheck(); });
    }
    return _origXHROpen.apply(this, arguments);
  };

  // ─── Init ───────────────────────────────────────────────────
  function init() {
    // JS-ін'єкція яєць по CSS-селектору
    placeEggsBySelector();
    // Перемаркуємо вже знайдені яйця (прибираємо з DOM)
    markFoundEggs();

    renderCounter();
    // checkSearchPageForGolden();
    // check404ForGolden();
    // checkProductTabForGolden();
    // checkSortForGolden();
    handleCartPage();
    processPendingGifts();
    cleanupGiftsIfNoRealItems();
    setTimeout(showWelcomeIfNeeded, 600);
  }

  // ─── Event delegation для кліків по яйцях ──────────────────
  // Ловимо кліки на будь-яких .easter-egg елементах, навіть якщо
  // вони з'явились на сторінці після завантаження (theme editor live preview,
  // динамічний контент, AJAX оновлення тощо).
  document.addEventListener('click', function (e) {
    var egg = e.target.closest && e.target.closest('.easter-egg');
    if (!egg) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    handleEggClick(egg);
  }, true); // capture phase

  // ─── Старт ─────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ─── Debug API ──────────────────────────────────────────────
  if (CFG.debug) {
    window.EasterHunt = {
      progress: function () { return progress; },
      reset: function () {
        localStorage.removeItem(STORAGE_KEY);
        progress = loadProgress();
        document.querySelectorAll('.easter-egg--found').forEach(function (e) { e.classList.remove('easter-egg--found'); });
        renderCounter();
        console.log('[EasterHunt] Progress reset');
      },
      resetGolden: function () {
        progress.goldenFound = false;
        progress.goldenClaimed = false;
        saveProgress(progress);
        document.querySelectorAll('.easter-egg--golden').forEach(function (e) { e.classList.remove('easter-egg--found'); });
        console.log('[EasterHunt] Golden reset');
      },
      setEggs: function (n) {
        progress.foundEggs = [];
        for (var i = 0; i < n; i++) progress.foundEggs.push('debug-' + i);
        saveProgress(progress);
        renderCounter();
        console.log('[EasterHunt] Eggs set to', n);
      },
      triggerTier: function (thr) {
        var t = CFG.tiers.find(function (x) { return x.threshold === thr; });
        if (t) awardTier(t);
      },
      triggerGolden: function () {
        progress.goldenFound = false;
        saveProgress(progress);
        handleGoldenEggClick(document.createElement('span'));
      },
      triggerWelcome: function () {
        progress.welcomeShown = false;
        saveProgress(progress);
        showWelcomeIfNeeded();
      }
    };
  }

})();
